<template>
  <ThePage>
    <div id="primary" class="content-area">
      <main id="main" class="site-main">
        <article id="sitemap" class="page type-page status-publish">
          <header class="entry-header">
            <h1 class="entry-title">{{ pageData?.sitemap?.title }}</h1>
          </header>
          <div class="entry-content sitemap-container">
            <SitemapList
              v-if="pageData?.sitemap?.articles && pageData.sitemap.articles.length > 0"
              :items="pageData.sitemap.articles"
            ></SitemapList>
            <div v-else-if="pageData?.sitemap?.category" class="sitemap-category">
              <p>
                <a :href="pageData.sitemap.category.url">{{ pageData.sitemap.category.name }}</a>
              </p>
              <SitemapList :items="pageData.sitemap.category.links"></SitemapList>
            </div>
            <div v-else-if="pageData?.sitemap?.brand" class="sitemap-categories_container">
              <div class="sitemap-category" v-for="category in pageData.sitemap.brand.categories">
                <p>
                  <a :href="category.url">{{ category.name }}</a>
                </p>
                <SitemapList :items="category.links"></SitemapList>
              </div>
            </div>
          </div>
        </article>
      </main>
    </div>
  </ThePage>
</template>

<script setup>
import pageHead from "~/utils/pageHead";
import SitemapList from '~/components/sitemap/SitemapList';
import { usePageStore } from "~/stores/page";
import { nextTick, onMounted } from "vue";
import { loadMediavine } from "~/utils/ads";

defineI18nRoute({
  paths: {
    es: '/mapa-del-sitio/[slug]',
    uk: '/sitemap/[slug]',
    en: '/sitemap/[slug]',
  },
})

const route = useRoute();
const request = useRequestEvent();

const page = usePageStore();

const pageData = ref({});

const payload = {
  ip: '',
  referer: '',
  'user-agent': '',
};

if (process.server) {
  const headers = useRequestHeaders();
  payload.referer = headers.referer || headers.referrer;
  payload['user-agent'] = headers['user-agent'];
  payload.ip =
    headers['x-real-ip'] ||
    (headers['x-forwarded-for']
      ? headers['x-forwarded-for'].split(',').pop()
      : request.req.connection
        ? request.req.connection.remoteAddress
        : '');
}

try {
  const { data } = await useApiFetch(`/api/pages/sitemap/${route.params.slug}`, {
    // key: 'sitemap' + (route.params.slug ? '_'+route.params.slug : ''),
    // params: payload,
  });

  page.fillSitemapPageData(data.value);

  if (page.redirectTo) {
    navigateTo(page.redirectTo, { redirectCode: 301, external: true });
  }

  pageData.value = data.value.page_data;
} catch (e) {
  if (e.type && e.type === 'not_found') {
    throw createError({ statusCode: 404, statusMessage: e.message });
  } else {
    throw e;
  }
}

const withMetaLinks = Object.keys(route.query).length === 0;

useHead(pageHead.getHead('', withMetaLinks))

onMounted(() => {
  nextTick(() => {
    loadMediavine();
  })
});
</script>

<style lang="scss" scoped>
.site-main {
  margin: 15px auto;
  max-width: 600px;
}
</style>
